<template>
  <div style="width:100%;height: 100%;margin-top: 5vh;" flex="main:center cross:center">
    <!--<img v-show="show" :src="path+'static/images/loading.gif'" style="width: .8rem;height: .8rem;position:absolute">-->
    <iframe :src="url" @load="onLoad" ref="iframe" style="width: 100%;height: 100%;border:none" :style="{visibility:show?'visible':'hidden'}" name="ifr"></iframe>
  </div>
</template>

<script>
  export default {
    name: "ConfigureView",
    data() {
      return {
        show:false,
      }
    },
    methods: {
      onLoad(evt) {
        setTimeout(()=>{
          var iframeDocument = window.frames['ifr'].document;
          if (this.$refs.iframe.document) {
            iframeDocument = this.$refs.iframe.document;
          }
          try {
            if (iframeDocument.getElementsByClassName('navbar')[0]) {
              iframeDocument.getElementsByClassName('navbar')[0].style.display = 'none';
            }
            if(iframeDocument.getElementsByClassName("intro_title___1hVhw")[0]){
              iframeDocument.getElementsByClassName("intro_title___1hVhw")[0].style.display = "none";
            }
            iframeDocument.getElementsByClassName("sidebar___1GOrl lock___2yHHQ")[0].style.display = "none";
            iframeDocument.getElementsByClassName("sidebar___1GOrl lock___2yHHQ")[0].style.opacity = "0";
            iframeDocument.getElementsByClassName("sidebar___1GOrl lock___2yHHQ")[0].style.pointerEvents = "none";
            iframeDocument.getElementsByClassName("footer___2a1ue")[0].style.display = "none";
            if (/Android|webOS|iPhone|BlackBerry/i.test(navigator.userAgent)) {
              if (iframeDocument.getElementsByClassName('intro_title___1hVhw')[0]) {
                iframeDocument.getElementsByClassName('intro_title___1hVhw')[0].style.display = 'none';
              }
              if (iframeDocument.getElementsByClassName('footer-container')[0]) {
                iframeDocument.getElementsByClassName('footer-container')[0].style.display = 'none';
              }
              if (iframeDocument.getElementsByClassName('content___3eOJC')[0]) {
                iframeDocument.getElementsByClassName('content___3eOJC')[0].style.paddingTop = '0px';
              }
            }
            this.$emit('load_success');
          } catch (e) {

          }
          this.show = true;
        },2000);
      }
    },
    props: {
      url: {
        default: '',
        type: String
      }
    },
    watch:{
      url: {
        handler(newVal) {
          this.show = false;
        },
        deep: true
      }
    },
    mounted() {
      if(this.$route.query.configUrl!=undefined){
        this.url = this.$route.query.configUrl;
      }
    }
  }
</script>

<style scoped>

</style>
